














import { Component, Vue } from 'nuxt-property-decorator'
import PageSeoMixin from '~/mixins/PageSeoMixin'
// import BlogDummy from '~/data/blogs/mock'
import { getItemsByLang } from '~/data/blogs/conversion'
import * as JoomlaExportUtils from '~/data/_joomlaExports/Joomlautils'
import BlogItem from '~/components/Blog/BlogItem.vue'
import BlogList from '~/components/Blog/BlogList.vue'
import * as BlogUtils from '~/utils/BlogUtils'
import * as PostsUtils from '~/utils/PostsUtils'
import PostList from '~/components/Post/PostList.vue'

const PAGE_SIZE = 15

@Component({
  name: 'BlogPage',
  components: { BlogItem, BlogList, PostList },
  mixins: [PageSeoMixin],
  watchQuery: true
})
export default class extends Vue {
  pageSize = PAGE_SIZE
  listCount = 0
  historyList = []
  page = 0
  pages = 0

  async asyncData({ query, app, $axios, $i18n }) {
    const page = query.page ? Number(query.page) : 1
    const r = await $axios.$get(
      `/api/posts/Blog/${PostsUtils.getLangToLoadByLocale(
        app.i18n._vm._data.locale
      )}`,
      {
        params: { page }
      }
    )
    // console.log(r)
    const list = r.Data
    const listCount = r.TotalCount
    const start = (page - 1) * PAGE_SIZE
    const end = page * PAGE_SIZE
    return {
      historyList: list,
      listCount,
      page,
      pages: Math.ceil(listCount / PAGE_SIZE)
    }
  }

  updatePage(pageIndex) {
    this.$router.push({
      query: {
        page: pageIndex
      }
    })
  }

  mounted() {}
}
